import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { Row, Col, Typography, Card, Skeleton, Image, Space, Pagination, Empty, Modal } from 'antd'
import { menuApplications, unmountMenuApplications, listApplications, unmountListApplications, detailHired, unmountHired } from '../../../../redux/actions/applications/applicationsAction'
import { SafetyOutlined, EnvironmentOutlined } from '@ant-design/icons'
import EmptyLogo from '../../../../assets/img/EmptyLogo.png';
import MenuApplications from '../Menu';
import CButton from '../../../../components/Button';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

const { Text } = Typography;

export class index extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      params: {
        page: 1,
        perpage: 10,
        // phaseId: 17,
        phaseId: 10,
        jobStatus: 'ACTIVE'
      },
      activeKey: "Hired",
      visibleDetail: false,
      isReschedule: false,
      submitLoading: false,
    }
  }
  
  componentDidMount() {
    const { params } = this.state
    const { actionMenuApplications, actionListApplications } = this.props

    return (actionMenuApplications(), actionListApplications(params))
  }

  handlePagination = (pageNumber) => {
    const { params: { perpage, phaseId, jobStatus } } = this.state
    const params = {
      page: pageNumber,
      perpage: perpage,
      phaseId: phaseId,
      jobStatus: jobStatus
    }
    this.setState({ params })
    window.scrollTo(0, 0);
    const { actionListApplications } = this.props
    return actionListApplications(params)
  }

  showModalDetail = (id) => {
    const { actionDetailHired } = this.props

    const params = {
      jobAppliedId: id
    }
    this.setState({
      visibleDetail: true
    })

    return actionDetailHired(params)
  }

  handleCancel = () => {
    this.setState({
      visibleDetail: false
    })
  }

  render() {
    const { activeKey, visibleDetail } = this.state
    const { t, getMenuApplications, getListApplications, getDetailHired } = this.props

    if(process.env.REACT_APP_ENV === "production"){
      ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Jobshub - Applications - Hired');
    }

    const initialProps = {
      activeKey: activeKey
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Jobshub - Applications - Hired</title>
        </Helmet>
        <Row className="padding-16">
          <Col className="width-100" md={{ span: 20, offset: 2 }}>
            <Row className="mb-32">
              <Col>
                <Text className="dark-color fs-20">{t('application.applications')}</Text>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col className="width-100" xs={24} lg={4}>
                {
                  getMenuApplications.loading ?
                    <Skeleton active />
                  :
                    <MenuApplications {...this.props} {...initialProps} />
                }
              </Col>
              <Col xs={24} lg={20}>
                <Row className="width-100 mb-8" gutter={8}>
                  <Col span={24}>
                    {
                      getListApplications.data ?
                        <Text className="dark-color fs-13">{`${t('application.assessment.showing')} ${getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : (getListApplications?.meta?.page*getListApplications?.meta?.perpage)-(getListApplications?.meta?.perpage-1)}-${getListApplications?.meta?.page === getListApplications?.meta?.pages || getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : getListApplications?.meta?.page*getListApplications?.meta?.perpage} of ${getListApplications?.meta?.total} ${t('application.assessment.job')}`}</Text>
                      :
                        <Skeleton.Input active />
                    }
                  </Col>
                </Row>
                <Row className="mb-16">
                  <Col span={24}>
                    {
                      getListApplications.loading ?
                        <Card className="border-radius-3 box-shadow mb-6">
                          <Skeleton active avatar />
                        </Card>
                      :
                        getListApplications?.data?.length > 0 ?
                          getListApplications?.data?.map(item => 
                            <Card className="border-radius-3 box-shadow mb-6">
                              <Row className="width-100" gutter={16} style={{ marginBottom: -10 }}>
                                <Col className="col-img-job" xs={24} sm={4} md={4}>
                                  {/* <Link to={`/candidate/company/${item.companyId}/${item.companyType}`}> */}
                                  <Link to={`/candidate/job/detail/${item.slug}`}>
                                    <Image
                                      src={item.companyLogoUrl ? item.companyLogoUrl : EmptyLogo}
                                      preview={false}
                                      width={'100%'}
                                      height={80}
                                      style={{ objectFit: 'contain' }}
                                    />
                                  </Link>
                                </Col>
                                <Col xs={24} sm={13} md={12}>
                                  <Space direction="vertical" size={0}>
                                    <Link to={`/candidate/job/detail/${item.slug}`}>
                                      <Text className="info-color fs-17">{item.title}</Text>
                                    </Link>
                                    <Text className="fs-13 dark-color">{item.companyName} {item.isVerified ? <SafetyOutlined className="primary-color" /> : null}</Text>
                                    <Text className="fs-13 dark-color"><EnvironmentOutlined /> {item.jobDestinationParentId ? `${item.jobDestinationName}, ${item.jobDestinationParentName}` : item.jobDestinationName}</Text>
                                  </Space>
                                </Col>
                                <Col xs={24} sm={7} md={8}>
                                  <Space direction="vertical" size={8} className="application-date">
                                    <Text className="application-date fs-13 dark-color">{`${t('application.assessment.applied')} ${item.applyDate}`}</Text>
                                    <CButton className="application-date mt-8 fs-12" type="primary" action={() => this.showModalDetail(item.id)} title={t('application.assessment.details')}/>
                                    <Modal 
                                      title={
                                        getDetailHired.loading ?
                                          <Skeleton paragraph={{ rows: 1 }} active />
                                        :
                                          <Space className="text-align-center width-100" direction="vertical">
                                            <Text className="fs-20 primary-color">{t('application.hired.hiredDetail')}</Text>
                                            <Text className="fs-15 dark-color">{`${getDetailHired?.data?.jobPositionName} - ${getDetailHired?.data?.companyName}`}</Text>
                                          </Space>
                                      } 
                                      visible={visibleDetail} 
                                      onCancel={this.handleCancel}
                                      footer={false}
                                    >
                                      {
                                        getDetailHired.loading ?
                                          <Skeleton active />
                                        :
                                          <React.Fragment>
                                            <Space className="width-100" direction="vertical">
                                              <Row className="mb-32" gutter={16}>
                                                <Col xs={6} sm={5}>
                                                  <Text>{t('application.hired.joinDate')}</Text>
                                                </Col>
                                                <Col xs={18} sm={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text strong> {moment(getDetailHired?.data?.joinDate, 'DD/MM/YYYY').format('DD MMMM YYYY')}</Text>
                                                  </Space>
                                                </Col>
                                                <Col xs={6} sm={5}>
                                                  <Text>{t('application.hired.notes')}</Text>
                                                </Col>
                                                <Col xs={18} sm={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailHired.data.notes ? getDetailHired.data.notes : '-' }}></div>
                                                  </Space>
                                                </Col>
                                              </Row>
                                              <Space className="float-right">
                                                <CButton className="fs-12" type="primary" action={this.handleCancel} title={t('application.assessment.okay')}/>
                                              </Space>
                                            </Space>
                                          </React.Fragment>
                                        }
                                    </Modal>
                                  </Space>
                                </Col>
                              </Row>
                          </Card>
                      )
                        :
                          <Card className="border-radius-3 box-shadow mb-6">
                            <Empty />
                          </Card>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col className="text-align-center" span={24}>
                    <Pagination onChange={this.handlePagination} current={getListApplications?.meta?.page} pageSize={getListApplications?.meta?.perpage || 10} total={getListApplications?.meta?.total} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  componentWillUnmount(){
    const { unmountMenuApplications, unmountListApplications, unmountHired } = this.props
    return (unmountMenuApplications(), unmountListApplications(), unmountHired())
  }
}

const mapStateToProps = (state) => ({
  getMenuApplications: state.menuApplicationsReducer,
  getListApplications: state.listApplicationsReducer,
  getDetailHired: state.hiredReducer
})

const mapDispatchToProps = {
  actionMenuApplications: menuApplications,
  unmountMenuApplications: unmountMenuApplications,
  actionListApplications: listApplications,
  unmountListApplications: unmountListApplications,
  actionDetailHired: detailHired,
  unmountHired: unmountHired
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(index))